var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineBg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 546,
    height: 426,
    viewBox: "0 0 546 426",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22_7271",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -144,
    y: 0,
    width: 768,
    height: 768
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 768,
    transform: "translate(-144)",
    fill: "url(#paint0_radial_22_7271)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22_7271)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_7271)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_22_7271)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 96.5,
    x2: 96.5,
    y1: 310,
    y2: 500,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.5,
    x2: 144.5,
    y1: 270,
    y2: 500,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.5,
    x2: 192.5,
    y1: 270,
    y2: 500,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.5,
    x2: 240.5,
    y1: 270,
    y2: 500,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.5,
    x2: 288.5,
    y1: 270,
    y2: 500,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.5,
    x2: 336.5,
    y1: 270,
    y2: 500,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.5,
    x2: 384.5,
    y1: 270,
    y2: 500,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432.5,
    x2: 432.5,
    y1: 270,
    y2: 500,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.5,
    x2: 480.5,
    y1: 310,
    y2: 500,
    stroke: "#EAECF0"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -143.5,
    y: 0.5,
    width: 767,
    height: 767,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_22_7271)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 108,
    y1: 287.5,
    x2: 440,
    y2: 287.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -144,
    y1: 335.5,
    x2: 624,
    y2: 335.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -144,
    y1: 383.5,
    x2: 624,
    y2: 383.5,
    stroke: "#EAECF0"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -143.5,
    y: 0.5,
    width: 767,
    height: 767,
    stroke: "#EAECF0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_22_7271",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(384 384) rotate(90) scale(384 384)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_7271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 768,
    fill: "white",
    transform: "translate(-144)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_22_7271"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -144,
    width: 768,
    height: 768,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_22_7271"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -144,
    width: 768,
    height: 768,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineBg2);
export default __webpack_public_path__ + "static/media/lineBg2.777adcd2ace0e1230fa1273007322588.svg";
export { ForwardRef as ReactComponent };